import { render, staticRenderFns } from "./OrgCreate.vue?vue&type=template&id=45f3c813&"
import script from "./OrgCreate.vue?vue&type=script&lang=js&"
export * from "./OrgCreate.vue?vue&type=script&lang=js&"
import style0 from "./OrgCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports